



























































import {Component, Vue } from "vue-property-decorator";
import CompanyApplyDialog from "@/components/CompanyApplyDialog.vue";
import InvestorApplyDialog from "@/components/InvestorApplyDialog.vue";
import ConfirmDialog from "@/components/confirmDialog.vue";
import PropertyCompanyApply from "@/components/PropertyCompanyApply.vue";
import CustodianApplyDialog from "@/components/CustodianApplyDialog.vue";

@Component({
  components:{
    'company-apply-dialog': CompanyApplyDialog,
    'investor-apply-dialog': InvestorApplyDialog,
    'confirm-dialog': ConfirmDialog,
    'property-company-apply': PropertyCompanyApply,
    'custodian-apply-dialog': CustodianApplyDialog,
  }
})
export default class Header extends Vue{
  //弹窗显示
  private dialog:any={
    companyApplyDialog:false,
    investorApplyDialog:false,
    confirmDialog:false,
    propertyCompanyApply:false,
    custodianApplyDialog:false
  }

  private navList:any = [
    {
      title: "首页",
      path: "/",
    },
    {
      title: "项目",
      path: "/project",
    },
    {
      title: "投资需求",
      path: "/demand",
    },
    {
      title: "投资人库",
      path: "/investor",
    },
  ];

  //跳转登录
  private onLogin(){
    window.location.replace('/login');
  }

}

